import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  CategoryMultiSelect,
  CategorySelectFormikField,
} from '../../../Category'
import { FieldStackedLabel } from '../../../Field'
import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import {
  USER_EDIT_CATEGORIES_MODAL_EMPTY_VALUES,
  USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES,
} from '../UserEditCategoriesModal.constants'

function UserEditCategoriesModalFields({ actionTypes, isLoading }) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: USER_EDIT_CATEGORIES_MODAL_EMPTY_VALUES,
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error: errors[USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES],
          options: actionTypes,
        }}
      >
        <CategorySelectFormikField
          multi
          Field={FieldStackedLabel}
          Select={CategoryMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                autoFocus: true,
                placeholder: t('Category.CategoryFieldPlaceholderKey'),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          fieldComponentProps={{
            isLoading,
            label: t('Category.CategoryFieldLabelKey'),
          }}
          name={USER_EDIT_CATEGORIES_MODAL_FIELD_NAME_CATEGORIES}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default UserEditCategoriesModalFields
